import { ChangeDetectorRef, Component, HostBinding, Input, OnInit, Optional, inject, DestroyRef } from '@angular/core';
import { TabSize } from '../../../types';

import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-tab-option',
  templateUrl: './tab-option.component.html',
  styleUrls: ['./tab-option.component.scss'],
  standalone: false,
})
export class TabOptionComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @HostBinding('class')
  private get classes(): string {
    return `font-main text-base hover:text-opacity-100 ${
      this.size
    } inline-flex flex-column justify-center items-center cursor-pointer relative ${
      this.progress ? 'pb-3 px-1.5' : ''
    }`;
  }

  @Input()
  size: TabSize = 'small';

  @Input()
  progress: number;

  @Input()
  progressColor: string;

  @Input()
  svgIconPath: string;

  @Input()
  count: number;

  @Input()
  hideCounterOnZero: boolean;

  @Input()
  notificationDot: boolean;

  @HostBinding('class.pointer-events-none')
  @HostBinding('class.opacity-50')
  @Input()
  disabled: boolean;

  @HostBinding('class.font-bold')
  @HostBinding('class.text-navy-90')
  @HostBinding('class.selected')
  @Input()
  selected: boolean;

  get shouldDisplayCount(): boolean {
    return !this.isNullOrUndefined(this.count) && (this.hideCounterOnZero ? this.count > 0 : this.count >= 0);
  }

  constructor(private router: Router, private cd: ChangeDetectorRef, @Optional() private routerLink: RouterLink) {}

  ngOnInit(): void {
    this.handleRouting();
  }

  isNullOrUndefined(value: unknown): boolean {
    return value === null || value === undefined;
  }

  private handleRouting(): void {
    if (!this.routerLink) {
      return;
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null), // to initially call subscriber
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.selected = this.router.isActive(this.routerLink.urlTree, {
          paths: 'subset',
          fragment: 'ignored',
          queryParams: 'ignored',
          matrixParams: 'ignored',
        });
        this.cd.markForCheck();
        this.cd.detectChanges();
      });
  }
}
